import React from 'react'

export const BlocksLayout = (props: { children: JSX.Element }) => (
  <div className="page__content">{props.children}</div>
)
